import {Box, Chip, Stack, Typography} from '@mui/material';
import {Question} from '@cp/model';

export interface AdminQuestionReviewQuestionHeaderProps {
  question: Question;
}

export default function AdminQuestionReviewQuestionHeader({question}: AdminQuestionReviewQuestionHeaderProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography variant="body2" color="text.secondary">
          {question.moduleTopic.category}
          {question.moduleTopic.topic ? ` • ${question.moduleTopic.topic}` : ''}
        </Typography>
      </Box>
      <Chip label={`Status: ${question.status}`} />
      <Box
        sx={{
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Typography variant="body2" sx={{fontWeight: 500}}>
          Difficulty: {question.difficulty}
        </Typography>
      </Box>
    </Stack>
  );
}
